// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"f63f936c","865":"c3f4f698"}[chunkId] + ".chunk.js";
};